var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import { listIndoorMaps } from "../api/venues";
import { setIsModalDeleteMap } from "../store/reducers/appSlice";
import "./App.scss";
import RootRoute from "../store/routes/RootRoute";
import Loader from "../components/loader";
import SearchBox from "../components/searchBox/SearchBox";
import translations from "../translations/resources/en-GB.json";
import HeaderComponent from "../components/header/HeaderComponent";
import Footer from "../components/Footer/Footer";
import { HDSButton } from "@here/hds-react-components/Button";
import useFetchMaps from "../pages/FirstPage/useFetchMaps";
import { isUserAuthenticated } from "../store/reducers/userSlice";
import { setIndoorMapSearchText } from "../store/reducers/venuesSlice";
import { useLocation } from "react-router-dom";
import { ConfirmDailog } from "../generic-components";
var App = function () {
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    // project scoped token
    var isProjectScoped = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.token; });
    var isAuthenticated = useSelector(isUserAuthenticated);
    //weather to show searchbar or not
    var displaySearchBarFor = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.displaySearchBarFor; });
    var isModalDeleteMap = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isModalDeleteMap; });
    var defaultCollectionHrn = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.overview.defaultHrn; });
    var selectedTab = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.selectedTab; });
    var venue = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.venue) === null || _a === void 0 ? void 0 : _a.venue; });
    var displaySearchBar = displaySearchBarFor.includes(selectedTab) && pathname === "/" && !(venue === null || venue === void 0 ? void 0 : venue.id);
    var indoorMapSearchText = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.indoorMapSearchText; });
    var isMapAPICalled = useSelector(function (state) { return state.app.isMapAPICalled; });
    var isRealmSetup = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isRealmSetup; });
    // below custom hook triggers getdraftlist, collectionhrn list and indoor map catalog
    var fetchEssentialMapData = useFetchMaps();
    useEffect(function () {
        // when draflist,collection hrns and catalog list ready call /maps api
        //fetchEssentialMapData denotes maps,if maps length is 0 and isMapAPICalled is false then only go inside
        // basically it denotes /map called already happened and being a new user api returned blank array
        if (fetchEssentialMapData &&
            (fetchEssentialMapData === null || fetchEssentialMapData === void 0 ? void 0 : fetchEssentialMapData.length) === 0 &&
            !isMapAPICalled &&
            defaultCollectionHrn &&
            isProjectScoped &&
            isRealmSetup) {
            dispatch(listIndoorMaps());
        }
    }, [
        isProjectScoped,
        fetchEssentialMapData,
        defaultCollectionHrn,
        isRealmSetup,
        isMapAPICalled,
    ]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "App" }, { children: [_jsx(HeaderComponent, {}), displaySearchBar ? (_jsx("div", __assign({ className: "searchContainer" }, { children: _jsx(SearchBox, { onChange: function (s) {
                                dispatch(setIndoorMapSearchText({
                                    isSearchClicked: true,
                                    indoorMapSearchText: s,
                                }));
                            }, searchText: indoorMapSearchText }) }))) : null, _jsxs("section", __assign({ className: "App-content" }, { children: [_jsx(Suspense, __assign({ fallback: _jsx(Loader, {}) }, { children: isAuthenticated && !!isProjectScoped ? _jsx(RootRoute, {}) : _jsx(Loader, {}) })), _jsx(Footer, {})] }))] })), isModalDeleteMap && (_jsx(ConfirmDailog, { id: "venue-list-map-modal", "data-test": "close-modal", "data-cy": "close-model", header: _jsx("div", __assign({ style: {
                        fontSize: "20px",
                        fontFamily: "FiraGO",
                        fontWeight: "bold",
                        color: "rgba(0, 10, 25, 0.8)",
                        width: "616px",
                    } }, { children: translations.data["venonboard.venueList.mapDeleteModal.heading"] })), onClose: function () { return dispatch(setIsModalDeleteMap(false)); }, renderBody: function () { return (_jsxs("div", __assign({ className: "mapModalContent" }, { children: [_jsx("p", { children: translations.data["venonboard.venueList.mapDeleteModal.para1"] }), _jsxs("p", { children: [translations.data["venonboard.venueList.mapDeleteModal.para2"], _jsx(HDSButton, __assign({ variant: "link", link: true, size: "large", style: { fontSize: "bold" } }, { children: "venues.support@here.com" }))] }), _jsx("p", { children: translations.data["venonboard.venueList.mapDeleteModal.para3"] })] }))); } }))] }));
};
export default App;
